import { render, staticRenderFns } from "./createNewPolicy.vue?vue&type=template&id=e4bca1a6&"
import script from "./createNewPolicy.vue?vue&type=script&lang=js&"
export * from "./createNewPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports